import { useState } from 'react';
import { Button, InfoItem, Text } from '@intellecteu/common-ui';
import { EnvVar } from 'data';
import { SidebarCollapsed } from 'ui';
import { ui } from 'ui/styles';

import s from './styles.module.scss';

export type EnvVarGroup = {
  label: string;
  envVars: EnvVar[];
};

export const EnvVarsInfo = ({ values }: { values: EnvVarGroup[] }) => {
  const [isShowAll, setIsShowAll] = useState<boolean>(false);

  const openModal = () => setIsShowAll(true);
  const closeModal = () => setIsShowAll(false);

  const totalEnvVars = values.reduce((sum, group) => sum + group.envVars.length, 0);
  const generateIndexToShowVars = (): number => {
    if (!values?.length) return 0;

    // find the index of the first group that has envVars
    const foundIndex = values.findIndex((group) => group.envVars.length > 0);

    return foundIndex !== -1 ? foundIndex : 0;
  };

  return (
    <>
      {isShowAll && (
        <SidebarCollapsed
          title={`Environment variables (${totalEnvVars})`}
          size="m"
          closeFunction={closeModal}
          overlayedItemId="env_vars"
          customFooter={
            <Button onClick={closeModal} className={ui.modalSubmitBtn}>
              Close
            </Button>
          }
        >
          {values.map(({ label, envVars }) => {
            return (
              <>
                <Text weight="bold" size={Text.size.s} className={ui.formSidebarSectionTitle}>
                  {label} {values?.length > 1 && `(${envVars.length})`}
                </Text>
                <ul>
                  {envVars.map(({ name, value, valueFrom }: EnvVar) => (
                    <InfoItem
                      key={name}
                      label={`${name}${valueFrom ? ' (secret)' : ''}`}
                      className={s.envVarsInfo}
                      value={
                        value || (
                          <div className={s.envVarsInfoValue}>
                            <InfoItem label="Key" value={valueFrom?.secretKeyRef?.key} />
                            <InfoItem label="Name" value={valueFrom?.secretKeyRef?.name} />
                          </div>
                        )
                      }
                    />
                  ))}
                </ul>
              </>
            );
          })}
        </SidebarCollapsed>
      )}

      <div className={s.envVars}>
        <div className={s.envVarsInfoValue}>
          <Text weight="bold" size={Text.size.s}>
            Environment variables ({totalEnvVars})
          </Text>

          {totalEnvVars > 0 && (
            <Button className={s.envVarsShowBtn} size="xs" variant="tertiary" onClick={openModal}>
              Show all
            </Button>
          )}
        </div>

        <ul>
          {values[generateIndexToShowVars()].envVars.slice(0, 3).map(({ name, value, valueFrom }: EnvVar) => (
            <InfoItem
              key={name}
              label={`${name}${valueFrom ? ' (secret)' : ''}`}
              className={s.envVarsInfo}
              value={
                value || (
                  <div className={s.envVarsInfoValue}>
                    <InfoItem label="Key" value={valueFrom?.secretKeyRef?.key} />
                    <InfoItem label="Name" value={valueFrom?.secretKeyRef?.name} />
                  </div>
                )
              }
            />
          ))}
        </ul>
      </div>
    </>
  );
};
